export default [
    {
        path: '/printer/:filter?',
        name: 'printer',
        component: () => import('@src/printer/printer'),
        meta: {
            title: 'Drucker',
            role: 'ROLE_LIST_PRINTER',
        },
    },
    {
        path: '/printer/create',
        name: 'printer_create',
        component: () => import('@src/printer/printer-create'),
        meta: {
            title: 'Drucker erstellen',
            role: 'ROLE_EDIT_PRINTER',
        },
    },
    {
        path: '/printer/edit/:id',
        name: 'printer_edit',
        props(route) {
            const props = { ...route.params };
            props.id = Number(props.id);

            return props;
        },
        component: () => import('@src/printer/printer-edit'),
        meta: {
            role: 'ROLE_EDIT_PRINTER',
        },
    },
];
